import { getPreferredCulture, getTranslations } from './localization';

export { getPreferredCulture } from './localization';

const withPreferredCulture = (url: string, browserLanguage = navigator.language): string => {
    const iframeUrl = new URL(url);
    const culture = getPreferredCulture(browserLanguage);
    const translations = getTranslations(browserLanguage);

    iframeUrl.searchParams.set('culture', culture);
    iframeUrl.searchParams.set('cartButtonText', translations.cartButtonText);

    return iframeUrl.toString();
};

export default withPreferredCulture;
